import { TCF_AC_STRING_VERSION } from "../constantsTCF";

/**
 * Generate AC string based on CMP info and user consents
 * @returns {string} The AC string representing the encoded consent information for accepted vendors.
 */
const TCFGenerateACString = (
  gacConsent: { [key: string]: boolean },
  gacVendorList: number[]
): string => {
  // Check if correct gvl is present
  const acceptedVendors: number[] = [];
  const nonAcceptedVendors: number[] = [];

  // Separate accepted from non accepted vendors to match acString v2
  for (const vendor of gacVendorList) {
    if (gacConsent[vendor]) {
      acceptedVendors.push(vendor);
    } else {
      nonAcceptedVendors.push(vendor);
    }
  }

  // Generate ac string
  const acString = `${TCF_AC_STRING_VERSION}~${acceptedVendors.join(
    "."
  )}~dv.${nonAcceptedVendors.join(".")}`;

  return acString;
};

export default TCFGenerateACString;
